export {
  convertSquareMetresToAcres,
  convertSquareMetresToHectares,
  convertDataToDataById,
  convertDataToDataByGranularId,
} from "./computations";

export {
  getGranularRuntimeEnvName,
  getEnvironmentFromUrl,
  getRuntimeEnvName,
  regexForGetOperationFromUrl,
  getRegexMatchingFromUrl,
} from "./url";

export type { ActionForUserCan } from "./roles";

export { getRoleFromPermissions, userCan } from "./roles";

export { getLocaleHelpCenterURL } from "./locale";

export { getUserType, UserType } from "./analytics";

export { getPlatform } from "./platform";
